import { actions, reducer } from './reducer';
import * as selectors from './selectors';
import { bookEditWorker } from './saga';

export const editBookModel = { actions, reducer, selectors, saga: bookEditWorker };
